module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAcCAYAAAAN3M1lAAAA3klEQVRYR+2YMQoCQQxFX6y0FrGwFO8gXkEQPILV3sYD2IpgbaFH8CLWHsDCLyO7sruoMM1Oipk6kMfPn0wyJmkF7IAx3ZwHcAQ2Zvb8ldIk3YBJN0yNLEszO7fzSuoB2wCmBFAhZWFmoVKfI2kAHIC1GzBJI+AEzAOpCzBJM+ACTCv5koNJWpRKDetlTQoG3IE90G/7PCXYtfSTfbt8KcH+NoMMFtsrs2JZsVgFYuOzx7JisQrExmePfVHM7SNeeB173jO/y0GxWkZcjtaV91wuIzW4xvrmduF1+UXwAgD+rNf7PXMTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liveLogo.png
// module id = Br39
// module chunks = 6